"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var styles_1 = require("@material-ui/core/styles");
var PrivateRoute_1 = __importDefault(require("../../PrivateRoute"));
var home_1 = __importDefault(require("../../../../home"));
var login_1 = __importDefault(require("../../../../login"));
var sgidLogin_1 = __importDefault(require("../../../../sgidLogin"));
var user_1 = __importDefault(require("../../../../user"));
var NotFoundPage_1 = __importDefault(require("../NotFoundPage"));
var directory_1 = __importDefault(require("../../../../directory"));
var MessageSnackbar_1 = __importDefault(require("../../MessageSnackbar"));
var ScrollToTop_1 = __importDefault(require("./ScrollToTop"));
var apiintegration_1 = __importDefault(require("../../../../apiintegration"));
// Add extra favicons to webpack bundle
require("@assets/favicon/android-chrome-192x192.png");
require("@assets/favicon/android-chrome-512x512.png");
require("@assets/favicon/apple-touch-icon.png");
require("@assets/favicon/favicon-16x16.png");
require("@assets/favicon/favicon-32x32.png");
var types_1 = require("../../../util/types");
var theme_1 = __importDefault(require("../../../theme"));
var Root = function (_a) {
    var store = _a.store, history = _a.history;
    return (react_1.default.createElement(react_redux_1.Provider, { store: store },
        react_1.default.createElement(styles_1.MuiThemeProvider, { theme: theme_1.default },
            react_1.default.createElement(react_router_dom_1.Router, { history: history },
                react_1.default.createElement(ScrollToTop_1.default, null,
                    react_1.default.createElement(react_router_dom_1.Switch, null,
                        react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: types_1.HOME_PAGE, component: home_1.default }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: types_1.LOGIN_PAGE, component: login_1.default }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: types_1.SGID_LOGIN_PAGE, component: sgidLogin_1.default }),
                        react_1.default.createElement(PrivateRoute_1.default, { path: types_1.USER_PAGE, component: user_1.default }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: types_1.NOT_FOUND_PAGE, component: NotFoundPage_1.default }),
                        react_1.default.createElement(PrivateRoute_1.default, { path: types_1.DIRECTORY_PAGE, component: directory_1.default }),
                        react_1.default.createElement(PrivateRoute_1.default, { path: types_1.API_INTEGRATION_PAGE, component: apiintegration_1.default }),
                        react_1.default.createElement(react_router_dom_1.Route, { component: NotFoundPage_1.default })))),
            react_1.default.createElement(MessageSnackbar_1.default, null))));
};
exports.default = Root;
